import { apiClient, getPlatformUrl, pollTask } from "../../lib/api";

export class CateGateway {
  async fetchOutcomeNodes(req: any): Promise<any> {
    const query = new URLSearchParams(req).toString();
    const url = `${getPlatformUrl()}/xcausal/cate/outcome?${query}`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchTreatmentNodes(req: any): Promise<any> {
    const query = new URLSearchParams(req).toString();
    const url = `${getPlatformUrl()}/xcausal/cate/treatment?${query}`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchConfoundingNodes(req: any): Promise<any> {
    const query = new URLSearchParams(req).toString();
    const url = `${getPlatformUrl()}/xcausal/cate/confounders?${query}`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchTreatmentHistogram(req: any): Promise<any> {
    const query = new URLSearchParams(req).toString();
    const url = `${getPlatformUrl()}/xcausal/cate/treatment_histogram?${query}`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchTreatmentSplitSummary(req: any): Promise<any> {
    const query = new URLSearchParams(req).toString();
    const url = `${getPlatformUrl()}/xcausal/cate/treatment_split_summary?${query}`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async calculateCate(req: any): Promise<any> {
    // message-queue（非同期）: POST → task_id → status ポーリング → result（一括版）
    const url = `${getPlatformUrl()}/api/message-queue/cate/`;
    const res: any = await apiClient.post({ url: url, body: req, useToken: true });
    const taskId = res?.task_id ?? res?.id;
    if (taskId) {
      return await pollTask(taskId);
    }
    return res as any;
  }

  // POST のみ（task_id を返す）。UI側で task_id を永続化しポーリングする用。
  async postCalculateCate(req: any): Promise<{ task_id: string }> {
    const url = `${getPlatformUrl()}/api/message-queue/cate/`;
    const res: any = await apiClient.post({ url, body: req, useToken: true });
    return { task_id: res?.task_id ?? res?.id };
  }

  async predictEffect(model_id: string, req: any): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/cate/${model_id}/predict_effect`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }

  async getITEOptions(model_id: string): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/cate/${model_id}/ite`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async getConditionalEffects(model_id: string, cate?: number): Promise<any> {
    let url = `${getPlatformUrl()}/xcausal/cate/${model_id}/conditional_effects`;
    if (cate !== undefined) {
      url += `?cate=${cate}`;
    }
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async listUserModels(): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/cate/models`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async renameModel(model_id: string, req: any): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/cate/models/${model_id}/rename`;
    const res = await apiClient.update({ url: url, body: req });
    return res as any;
  }

  async deleteModel(model_id: string): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/cate/models/${model_id}`;
    const res = await apiClient.remove({ url: url });
    return res as any;
  }

}